export default __webpack_public_path__ + "static/media/qr-code-challenge.c684a90e.png";